import { render, staticRenderFns } from "./PermissionsModuleTable.vue?vue&type=template&id=837e4544&scoped=true&"
import script from "./PermissionsModuleTable.vue?vue&type=script&lang=js&"
export * from "./PermissionsModuleTable.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsModuleTable.vue?vue&type=style&index=0&id=837e4544&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837e4544",
  null
  
)

export default component.exports